/** Base da regra variável do valor mínimo do saldo (o mínimo é a variável × multiplicador). */
export enum VariavelValorMinimo {
  Salario = 'Salario',
  SalarioMinimo = 'SalarioMinimo',
  Saldo = 'Saldo',
  UnidadePrevidenciaria = 'UnidadePrevidenciaria',
}
